<template>
  <div>
    <v-card v-if="editedItemBank">
      <v-toolbar>
        <v-btn icon @click="closeBankEdit">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Редактировать банк: {{ editedItemBank.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="saveBankEdit">
          <v-icon left>save</v-icon>Записать
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-5">
        <v-text-field
          v-model="editedItemBank.name"
          label="Название"
        ></v-text-field>
        <v-textarea
          v-model="editedItemBank.name_note"
          label="Название (примечание)"
        ></v-textarea>
        <SelectTags
          v-model="editedItemBank.tags"
          :readOnly="role() !== roleObj.bankir ? true : false"
        />
        <v-text-field
          v-model="editedItemBank.fullname"
          label="Полное название"
        ></v-text-field>
        <v-textarea
          v-model="editedItemBank.fullname_note"
          label="Полное название примечание"
        ></v-textarea>
        <v-select
          v-model="editedItemBank.partnership"
          :items="activate"
          item-text="label"
          item-value="value"
          label="Партнерские отношения"
        ></v-select>
        <v-textarea
          v-model="editedItemBank.partnership_note"
          label="Партнерские отношения (примечание)"
        ></v-textarea>
        <v-text-field
          v-model="editedItemBank.inn"
          label="ИНН банка"
        ></v-text-field>
        <v-textarea
          v-model="editedItemBank.inn_note"
          label="Инн банка (примечание)"
        ></v-textarea>
        <v-text-field
          v-model="editedItemBank.license"
          label="Лицензия"
        ></v-text-field>
        <v-textarea
          v-model="editedItemBank.license_note"
          label="Регистрационный номер (примечание)"
        ></v-textarea>
        <v-checkbox
          v-model="editedItemBank.outside_request"
          label="Рассмотрение нестандартных заявок"
        ></v-checkbox>
        <v-textarea
          v-model="editedItemBank.outside_request_note"
          label="Рассмотрение нестандартных заявок (примечание)"
        ></v-textarea>
        <v-checkbox
          v-model="editedItemBank.credit_contract"
          label="Выдает кредит на исполнение контракта/договора"
        ></v-checkbox>
        <v-textarea
          v-model="editedItemBank.credit_contract_yes_more"
          label="Кредит на исполнение контракта/договора (примечание):"
        ></v-textarea>
        <v-select
          v-model="purchasesVal"
          :items="purchases"
          label="Перечни"
          item-text="name"
          item-value="id"
          chips
          multiple
        ></v-select>
        <v-textarea
          v-model="editedItemBank.list_note"
          label="перечни (примечание):"
        ></v-textarea>
        <!-- <v-text-field
          v-model="editedItemBank.website"
          label="Сайт банка:"
        ></v-text-field> -->
        <Website
          v-model="editedItemBank.website"
          :readonly="role() !== roleObj.bankir ? true : false"
          :label="
            role() !== roleObj.bankir
              ? `Сайт банка (только чтение)`
              : `Сайт банка`
          "
        />
        <v-textarea
          v-model="editedItemBank.website_note"
          label="Сайт банка (примечание):"
        ></v-textarea>
        <v-select
          v-model="editedItemBank.acra"
          :items="acra"
          label="Рейтинг банка «АКРА»"
          item-text="name"
          item-value="id"
          chips
        ></v-select>
        <v-textarea
          v-model="editedItemBank.acra_note"
          label="Рейтинг «АКРА» (примечание):"
        ></v-textarea>
        <v-select
          v-model="editedItemBank.raexpert"
          :items="raexpert"
          label="Рейтинг банка от «Эксперт РА»:"
          item-text="name"
          item-value="id"
          chips
        ></v-select>
        <v-textarea
          v-model="editedItemBank.raexpert_note"
          label="Рейтинг «Эксперт РА» (примечание):"
        ></v-textarea>

        <v-select
          v-model="editedItemBank.npa"
          :items="npa"
          label="Рейтинг банка от «НРА»:"
          item-text="name"
          item-value="id"
          chips
        ></v-select>
        <v-textarea
          v-model="editedItemBank.npa_note"
          label="Рейтинг «НРА» (примечание):"
        ></v-textarea>

        <v-select
          v-model="editedItemBank.nkp"
          :items="nkp"
          label="Рейтинг банка от «НКР»:"
          item-text="name"
          item-value="id"
          chips
        ></v-select>
        <v-textarea
          v-model="editedItemBank.nkp_note"
          label="Рейтинг НКР (примечание):"
        ></v-textarea>

        <v-text-field
          v-model="editedItemBank.capital"
          type="number"
          label="Капитал, тыс. руб.:"
        ></v-text-field>

        <v-textarea
          v-model="editedItemBank.capital_note"
          label="Капитал (примечание):"
        ></v-textarea>
        <v-text-field
          v-model="editedItemBank.assets"
          type="number"
          label="Активы, тыс. руб.:"
        ></v-text-field>
        <v-textarea
          v-model="editedItemBank.assets_note"
          label="Активы (примечание):"
        ></v-textarea>

        <v-layout row>
          <v-flex xs12 md4 class="pl-4">
            <v-text-field
              v-model="editedItemBank.logo"
              :label="
                role() !== roleObj.bankir
                  ? 'Логотип (только чтение):'
                  : 'Логотип:'
              "
              :readonly="role() !== roleObj.bankir ? true : false"
            />
            <!-- :rules="logoRules" -->
            <!-- required -->
            <!-- <div>Лого</div>
            <template v-if="editedItemBank.logo">
              <v-img
                max-width="100"
                max-height="100"
                :src="getImage(editedItemBank.logo)"
              ></v-img>
            </template> -->
          </v-flex>
          <!-- <v-flex xs12 md11>
            <input
              type="file"
              class="custom-file-input"
              id="customFile"
              @change="onAttachmentChange"
            />
            <v-btn @click="updateImage">Загрузить</v-btn>
          </v-flex> -->
        </v-layout>

        <v-select
          v-model="editedItemBank.active"
          :items="activate"
          item-text="label"
          item-value="value"
          :label="
            role() !== roleObj.bankir
              ? 'Активировано (только чтение):'
              : 'Активировано:'
          "
          :readonly="role() !== roleObj.bankir ? true : false"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeBankEdit">Отмена (закрыть)</v-btn>
        <v-btn @click="saveBankEdit">Записать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Website from "./components/website.vue";
import SelectTags from "./EditBank/SelectTags.vue";
import { roleObj } from "../../plugins/roles";

export default {
  components: { Website, SelectTags },
  data() {
    return {
      roleObj,
      activate: [
        { label: "да", value: 1 },
        { label: "нет", value: 0 },
      ],
      logoRules: [
        (v) => !!v || "Лого обязателен в виде строки BASE64",
        (v) => {
          const reg = /data:image\/(\w+);base64,/;
          return reg.test(v) ? true : "Это не Base64 (data:image/TYPE;base64,)";
        },
      ],
      purchasesVal: [],
    };
  },
  created() {
    if (this.$store.getters.getPurchasesValCS.length == 0) {
      this.$router.push("/calcsettings");
    }
  },
  mounted() {
    this.purchasesVal = this.$store.getters.getPurchasesValCS;
    this.editedItemBank &&
      this.setTitle(`Редактировать банк: ${this.editedItemBank.name}`);
  },
  methods: {
    closeBankEdit() {
      this.$store.commit("SET_CURRENT_BANKCS", {});
      this.$router.push({ name: "calcsettings" });
    },
    saveBankEdit() {
      var formArr = Object.assign({}, this.editedItemBank);
      if (this.purchasesVal.length) {
        formArr.list = this.purchasesVal.join();
      } else {
        formArr.list = "";
      }
      this.$store.dispatch("updateBankCS", formArr).then(() => {
        this.$store.commit("SET_CURRENT_BANKCS", {});
      });
      this.$router.push({ name: "calcsettings" });
    },
    updateImage() {},
    onAttachmentChange() {},
    getImage() {
      //return "http://localhost:8081/storage/uploads/" + url;
      //return this.$http.options.root + "/storage/uploads/" + url;
    },
  },
  computed: {
    editedItemBank() {
      return this.$store.getters.getCurrentBankCS;
    },
    // purchasesVal() {
    //   return this.$store.getters.getPurchasesVal;
    // },
    purchases() {
      return this.$store.getters.getPurchasesCS;
    },
    acra() {
      return this.$store.getters.getAcraCS;
    },
    raexpert() {
      return this.$store.getters.getRaExperdCS;
    },
    nkp() {
      return this.$store.getters.getNKP;
    },
    npa() {
      return this.$store.getters.getNPA;
    },
  },
};
</script>

<style lang="scss"></style>
